import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Settings from 'src/Settings';
interface IProps {
  size?: number;
  color?: string;
}
const NewAccountTabOutline = ({size = 34, color = '#727179'}: IProps) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 33 32" fill="none">
      <Path
        d="M27.1667 28V25.3333C27.1667 23.9188 26.6048 22.5623 25.6046 21.5621C24.6044 20.5619 23.2478 20 21.8333 20H11.1667C9.75219 20 8.39563 20.5619 7.39544 21.5621C6.39525 22.5623 5.83334 23.9188 5.83334 25.3333V28M21.8333 9.33333C21.8333 12.2789 19.4455 14.6667 16.5 14.6667C13.5545 14.6667 11.1667 12.2789 11.1667 9.33333C11.1667 6.38781 13.5545 4 16.5 4C19.4455 4 21.8333 6.38781 21.8333 9.33333Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
export default NewAccountTabOutline;
